import React, { useState, useEffect } from "react";
// @ts-ignore
import styled from "styled-components";

import Header from "../../components/Header/Header";
import CustomAlert from "./components/alert";
import Certificate from "./components/certificate";
import CustomDialog from "./components/dialog";
import { getCertificate } from "../../services/api/certificate-service";
import { ICertificate } from "../../types";
import CertificateForm from "./components/certificate-form";
import { LoaderWithContent } from "./components/loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

export default function Certification() {
  const [certificate, setCertificate] = useState<ICertificate>();
  const [errorMessage, setErrorMessage] = useState(null);

  const [imageUri, setImageUri] = useState(
    document.querySelector("canvas")?.toDataURL()
  );

  useEffect(() => {
    const qrCodeCanvas = document.querySelector("canvas")?.toDataURL();
    setImageUri(qrCodeCanvas);
  }, [certificate]);

  const handleSubmit = async (epiNumber: string) => {
    const modal = CustomDialog(
      "info",
      "",
      <LoaderWithContent content="Fetching Certificate..." />,
      false,
      () => {},
      "20rem"
    );

    const response = await getCertificate(epiNumber);
    response.statusCode
      ? setErrorMessage(response.message)
      : setCertificate(response);

    modal.close();
  };

  return (
    <Wrapper>
      <Header />
      <ContentWrapper>
        {!certificate ? (
          <>
            <AlertWrapper>
              {errorMessage ? (
                <CustomAlert
                  title="error"
                  severity="error"
                  message={errorMessage}
                />
              ) : null}
            </AlertWrapper>
            <CertificateForm onSubmit={handleSubmit} />
            {/* <Alert severity="info" className={classes.icon}>
              <InfoText>for any issues please call 929</InfoText>
            </Alert> */}
            <InfoBox>
              <FontAwesomeIcon
                icon={faInfoCircle}
                color={"#3CA0F4"}
                size={"lg"}
              />
              <InfoText>For any issues please call 929</InfoText>
            </InfoBox>
          </>
        ) : (
          <Certificate imageUri={imageUri} certificate={certificate} />
        )}
      </ContentWrapper>
    </Wrapper>
  );
}
const InfoBox = styled.div`
  padding: 11px;
  background-color: #e7f4fd;
`;

const InfoText = styled.p`
  font-size: larger;
  font-weight: 100;
  align-self: flex-start;
  color: grey;
`;

const AlertWrapper = styled.div`
  margin-top: 10rem;
  height: 5rem;
  width: 100%;

  @media (max-width: 960px) {
    margin-top: 0rem;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 1rem 1rem 30rem;
  width: fit-content;

  @media (max-width: 960px) {
    margin: 0;
  }
`;
